// Recovered compiled webpack factory 43316. Edit this function expression; run npm run build.
(e, t, r) => {
  "use strict";
  r.d(t, { f: () => i, r: () => o });
  var n = r(73314);
  let a = "_sentrySpan";
  function o(e, t) {
    t ? (0, n.my)(e, a, t) : delete e[a];
  }
  function i(e) {
    return e[a];
  }
}
